"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTypedName = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const withTypedName = (UIComponent) => {
    const RetComponent = ({ name, ...props }) => {
        const realKeyName = Array.isArray(name) ? name.join(".") : name;
        return (
        // @ts-ignore
        (0, jsx_runtime_1.jsx)(UIComponent, { ...(props), name: realKeyName.toString() }));
    };
    return RetComponent;
};
exports.withTypedName = withTypedName;
